'use strict';

require('../vendor');

require('lazysizes/plugins/object-fit/ls.object-fit');

require('lazysizes/plugins/parent-fit/ls.parent-fit');

require('lazysizes/plugins/rias/ls.rias');

require('lazysizes/plugins/bgset/ls.bgset');

require('lazysizes');

require('lazysizes/plugins/respimg/ls.respimg');

var _jsCookie = require('js-cookie');

var _jsCookie2 = _interopRequireDefault(_jsCookie);

require('../utils/class-list-polyfill');

require('../utils/focus-ring');

var _preact = require('preact');

var _rellax = require('rellax');

var _rellax2 = _interopRequireDefault(_rellax);

require('../../styles/theme.pcss');

var _functional = require('../utils/functional');

var _utils = require('../utils');

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

var _PushCart = require('../components/PushCart/PushCart');

var _PushCart2 = _interopRequireDefault(_PushCart);

var _PushComplimentaryModal = require('../components/PushCart/PushComplimentaryModal');

var _PushComplimentaryModal2 = _interopRequireDefault(_PushComplimentaryModal);

var _inViewport = require('../modules/in-viewport');

var _inViewport2 = _interopRequireDefault(_inViewport);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// eslint-disable-next-line no-unused-vars
window.slate = window.slate || {};
// eslint-disable-next-line no-unused-vars


// eslint-disable-next-line no-unused-vars

window.theme = window.theme || {};
window.$ = _jquery2.default;
window.jQuery = _jquery2.default;
// window.ShopifyAPI = cart
window.Cookies = _jsCookie2.default;

document.addEventListener('DOMContentLoaded', function () {
  if ((0, _functional.getElement)('.js-InViewport')) {
    new _inViewport2.default((0, _functional.getElements)('.js-InViewport'));
  }

  // This adds the push cart
  window.setTimeout(function () {
    var rootNode = (0, _functional.getElement)('#VanillaCartContainer');
    var rootNodeModal = (0, _functional.getElement)('#complimentary-products-modal');
    var action = rootNode.dataset.action;
    var submitTo = rootNode.dataset.submitTo;
    var translations = {
      checkout: rootNode.dataset.translationCheckout,
      subtotal: rootNode.dataset.translationSubtotal,
      continue: rootNode.dataset.translationContinue,
      title: rootNode.dataset.translationTitle,
      complimentary: rootNode.dataset.translationComplimentary,
      selected: rootNode.dataset.translationSelected,
      complimentaryModalTitle: rootNode.dataset.translationComplimentaryModalTitle,
      recommendedTitle: rootNode.dataset.translationRecommendedTitle,
      recommendedTitleMobile: rootNode.dataset.translationRecommendedTitleMobile
    };
    var upsell = {
      enable: rootNode.dataset.upsellEnable,
      title: rootNode.dataset.upsellTitle,
      productHandle: rootNode.dataset.upsellProduct,
      addedTitle: rootNode.dataset.upsellAddedTitle,
      addedText: rootNode.dataset.upsellAddedText,
      addedLink: rootNode.dataset.upsellAddedLink,
      fallbackProductHandle: rootNode.dataset.upsellProductFallbackHandle
    };

    var complimentary = {
      enable: rootNode.dataset.complimentaryEnable,
      max: parseInt(rootNode.dataset.complimentaryMax),
      products: rootNode.dataset.complimentaryProducts,
      min_price: parseInt(rootNode.dataset.complimentaryMinPrice)
    };

    (0, _preact.render)((0, _preact.h)(_PushCart2.default, {
      action: action,
      translations: translations,
      upsell: upsell,
      complimentary: complimentary,
      submitTo: submitTo
    }), rootNode.parentNode, rootNode);

    (0, _preact.render)((0, _preact.h)(_PushComplimentaryModal2.default, {
      complimentary: complimentary,
      translations: translations
    }), rootNodeModal.parentNode, rootNodeModal);
  }, 0);

  if ((0, _functional.getElement)('.js-Parallax')) {
    var rellax = new _rellax2.default('.js-Parallax', {
      center: true,
      vertical: true,
      horizontal: false
    });
    var rellaxIsActive = true;

    var resizeFnc = function resizeFnc() {
      if (window.innerWidth <= _utils.mediaBreakpoints.md && rellaxIsActive) {
        rellax.destroy();
      } else if (window.innerWidth > _utils.mediaBreakpoints.md && rellaxIsActive === false) {
        rellax.refresh();
      }
    };
    resizeFnc();
    window.addEventListener('resize', (0, _utils.debounce)(resizeFnc, 50));
  }

  (0, _utils.externalLinks)();
  (0, _utils.wrapTables)({
    elements: (0, _functional.getElements)('.rte-RichText table')
  });
  (0, _utils.wrapIframes)({
    elements: (0, _functional.getElements)('.rte-RichText iframe')
  });
  (0, _utils.wrapImages)({
    elements: (0, _functional.getElements)('.rte-RichText img')
  });

  (0, _functional.getElements)('[data-module]').forEach(function (el) {
    var name = el.getAttribute('data-module');
    var Module = require('../modules/' + name).default;
    new Module(el);
  });

  // If the device is iOS add a class to the body so we can do specific CSS for it
  if (!!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform)) {
    var _body = document.body || document.documentElement;
    _body.classList.add('is-iOS');
  }

  if (window.location.pathname.includes('/challenge')) {
    window.setTimeout(function () {
      window.scrollTo(0, 0);
    }, 1);
  }

  (0, _functional.setCountryCode)();
});

/****
 * Setup CSS Grid & CSS Vars fallbacks
 ****/
var body = document.body || document.documentElement;
body.classList.add('util-JSEnabled');

if ('grid' in body.style === false) {
  require('../utils/css-grid-fallback');
  body.className += ' util-NoGrid';
}

function hasNativeCSSProperties() {
  var opacity = '0';
  var el = body;
  // Setup CSS properties.
  el.style.setProperty('--test-opacity', opacity);
  el.style.setProperty('opacity', 'var(--test-opacity)');
  // Feature detect then remove all set properties.
  var hasNativeCSSProperties = window.getComputedStyle(el).opacity === opacity;
  el.style.setProperty('--test-opacity', '');
  el.style.opacity = '';
  return hasNativeCSSProperties;
}

if (hasNativeCSSProperties() === false) {
  require('../utils/vars-fallback');
  body.className += ' util-NoCssVars';
}